exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".custom-appointment-info{overflow-x:hidden;width:100%;background-color:#fff}.custom-appointment-info .review-container{flex-direction:column;padding-bottom:35px}.custom-appointment-info .review-container .coverage-detail-container{width:333px;margin:0 0 15px 0;box-shadow:0px 2px 3px rgba(0,0,0,.1607843137);border-radius:4px;background-color:#fff}.custom-appointment-info .review-container .coverage-detail-container{height:166px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/Appointment/ScheduleAppointment.scss
// module id = 8117
// module chunks = 11